import React from "react";
import { SovosButton } from "mosaic-react";

export const ActionButtonOutlined = ({ link, title, i18n, history }) => {
    return (
        <>
            <SovosButton
                size="small"
                onClick={() => {
                    history.push(`${link}`);
                }}
                children={i18n`${title}`}
                variant={"outlined"}
                sx={{ margin: "10px" }}
            ></SovosButton>
        </>
    );
};
